<template>
  <div class="user" :data-name="userFullName">
    <AppTooltip :active="tooltip" size="small" :message="userFullName">
      <template #tooltip-handler>
        <AppAvatar v-if="avatarImage" :src="avatarImage" :alt="user.username" :size="mediaSize" />
        <UserShortName v-else :shortName="shortName" :class="mediaSize" />
      </template>
    </AppTooltip>
  </div>
</template>

<script>
// Components
import AppAvatar from 'Ui/AppAvatar'
import AppTooltip from 'Ui/AppTooltip'
import UserShortName from 'Components/UserShortName'

export default {
  name: 'UserAvatar',

  components: {
    AppAvatar,
    AppTooltip,
    UserShortName,
  },

  props: {
    user: {
      type: Object,
      required: true,
    },

    tooltip: {
      type: Boolean,
      default: true,
    },

    size: {
      type: String,
      default: 'small',
    },
  },

  computed: {
    userFullName() {
      return `${this.user.first_name} ${this.user.last_name}`
    },

    shortName() {
      const firstNameLetter = this.user.first_name.slice(0, 1)
      const firstLastNameLetter = this.user.last_name.slice(0, 1)
      return firstNameLetter + firstLastNameLetter
    },

    avatarImage() {
      return this.user.avatar
    },

    mediaSize() {
      return `image--${this.size}`
    },
  },
}
</script>

<style scoped>
.user {
  display: flex;
  position: relative;
  user-select: none;
}
</style>
